import React from 'react';
export function Card({
  className = '',
  children
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={`bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden ${className}`} data-id="element-371">
      {children}
    </div>;
}
export function CardHeader({
  className = '',
  children
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={`px-6 py-4 border-b border-slate-100 bg-slate-50/50 ${className}`} data-id="element-372">
      {children}
    </div>;
}
export function CardTitle({
  className = '',
  children
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <h3 className={`text-lg font-semibold text-slate-800 ${className}`} data-id="element-373">
      {children}
    </h3>;
}
export function CardContent({
  className = '',
  children
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={`p-6 ${className}`} data-id="element-374">{children}</div>;
}